<h2 mat-dialog-title>
  <mat-icon color="warn" style="vertical-align: middle;">warning</mat-icon>
  {{ data.title || 'Delete' }}
</h2>
<mat-dialog-content>
  <p>{{ data.message || 'Are you sure you want to delete this item?' }}</p>
</mat-dialog-content>
<mat-dialog-actions align="end">
  <button mat-button mat-dialog-close type="button">{{ data.cancelText || 'Cancel' }}</button>
  <button mat-flat-button color="warn" [mat-dialog-close]="true" type="button">
    {{ data.confirmText || 'Delete' }}
  </button>
</mat-dialog-actions>
